import { getFragmentData } from "gql/apollo";
import {
	darkWebStreamFieldsFragmentDoc,
	getStreamApolloQuery,
	incidentStreamFieldsFragmentDoc,
	standardStreamFieldsFragmentDoc,
	webAlertsStreamFieldsFragmentDoc,
} from "gql/apollo/graphql";

export function resolveStreamFragmentData(
	stream: NonNullable<getStreamApolloQuery["newGetStream"]>
) {
	switch (stream.__typename) {
		case "StandardStream":
			return {
				...stream,
				...getFragmentData(standardStreamFieldsFragmentDoc, stream),
			};

		case "IncidentStream":
			return {
				...stream,
				...getFragmentData(incidentStreamFieldsFragmentDoc, stream),
			};

		case "DarkWebStream":
			return {
				...stream,
				...getFragmentData(darkWebStreamFieldsFragmentDoc, stream),
			};

		case "WebAlertsStream":
			return {
				...stream,
				...getFragmentData(webAlertsStreamFieldsFragmentDoc, stream),
			};
	}
}
